<template>
  <div class="main background-gradient">
    <div class="containerBlock">
      
      <div class="methodsDeposit">
        <div class="tabs-wrapper">
          <div class="tabs-inner">
            <span 
              v-for="tab in tabList" 
              :key="tab"
              :class="['tab-item', { active: currentTab === tab }]"
              @click="selectTab(tab)"
            >{{ $t(tab) }}</span>
          </div>
        </div>
        
        <ul class="eWalletList">
          <li 
            v-for="method in filteredPaymentMethods" 
            :key="method.id"
            :class="['wallet-item', { active: selectedPaymentMethod && selectedPaymentMethod.id === method.id }]"
            @click="selectPaymentMethod(method)"
          >
            <div v-if="method.bonus" class="bonus-ribbon">
              <span>{{ method.bonus }}</span>
            </div>
            <div class="method-content">
              <div class="img-box">
                <img :src="method.img" alt="">
              </div>
              <span class="method-name">{{ method.name }}</span>
            </div>
            <div v-if="selectedPaymentMethod && selectedPaymentMethod.id === method.id" class="check-mark"></div>
          </li>
        </ul>
      </div>

      <div class="depositAmountSet">
        <div class="amount-header">
          <span class="title">{{ $t('Deposit Amount') }}</span>
          <a v-if="selectedPaymentMethod && selectedPaymentMethod.download_name && selectedPaymentMethod.download_url" :href="selectedPaymentMethod.download_url" target="_blank" class="download-btn">
            <i class="icon-download"></i> {{ selectedPaymentMethod.download_name }}
          </a>
        </div>
        
        <div class="amount-input-wrapper">
          <span class="currency">R$</span>
          <input 
            type="number" 
            v-model="depositAmount" 
            class="amount-input"
            placeholder="0.00"
            :min="selectedPaymentMethod ? selectedPaymentMethod.min_price : 0"
            :max="selectedPaymentMethod ? selectedPaymentMethod.max_price : 999999"
          >
          <div v-if="selectedPaymentMethod && selectedPaymentMethod.remark" class="payment-remark">
            <span>{{ selectedPaymentMethod.remark }}</span>
          </div>
        </div>
        
        <div class="quick-amount-grid">
          <span @click="selectAmount(100)" :class="['quick-btn', { active: depositAmount == 100 }]">100</span>
          <span @click="selectAmount(200)" :class="['quick-btn', { active: depositAmount == 200 }]">200</span>
          <span @click="selectAmount(500)" :class="['quick-btn', { active: depositAmount == 500 }]">500</span>
          <span @click="selectAmount(1000)" :class="['quick-btn', { active: depositAmount == 1000 }]">1,000</span>
          <span @click="selectAmount(2000)" :class="['quick-btn', { active: depositAmount == 2000 }]">2,000</span>
          <span @click="selectAmount(5000)" :class="['quick-btn', { active: depositAmount == 5000 }]">5,000</span>
          <span @click="selectAmount(10000)" :class="['quick-btn', { active: depositAmount == 10000 }]">{{ $t('10K') }}</span>
          <span @click="selectAmount(30000)" :class="['quick-btn', { active: depositAmount == 30000 }]">{{ $t('30K') }}</span>
          <span @click="selectAmount(50000)" :class="['quick-btn', { active: depositAmount == 50000 }]">{{ $t('50K') }}</span>
          <span @click="selectAmount(100000)" :class="['quick-btn', { active: depositAmount == 100000 }]">{{ $t('100K') }}</span>
        </div>
      </div>
      
      <div class="submit-action">
        <button 
          :class="['btn-submit', { disabled: !canSubmit }]"
          @click="confirmDeposit"
        >
          <span class="btn-text">{{ $t('Confirm Deposit') }}</span>
          <span class="btn-light"></span>
        </button>
      </div>
      
    </div>
  </div>
</template>

<script>
import { isKefuRechargePage } from '@/utils/deposit';

export default {
  name: 'recharge',
  data() {
    return {
      pay_way: '',
      bankBox: {},
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      meyXi: 'TRC20',
      payWayList: {},
      payTypeList: [],
      payMethods: {},
      currentPayMethods: [],
      selectedMethod: null,
      show: false,
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
      currentTab: 'Hot', // 改用英文Key维持内部逻辑
      tabList: [
        'Hot',
        // 'Wallet',
        // 'Alipay',
        // 'WeChat',
        // 'Other',
      ],
      categoryMap: {
        'Hot': 'hot',
        'Wallet': 'wallet',
        'Alipay': 'alipay',
        'WeChat': 'wechat',
        'Other': 'other'
      },
      allPaymentMethods: [],
      selectedPaymentMethod: null,
      depositAmount: '',
    };
  },
  created() {
    let that = this;
    if (that.redirectIfKefu()) return;
    that.getPayWay();
    that.getBanklist();
    that.getPaymentMethodsFromBackend();
  },
  watch: {
    '$store.state.appInfo.recharge_kefu_page'() {
      this.redirectIfKefu();
    },
  },
  methods: {
    redirectIfKefu() {
      if (isKefuRechargePage(this.$store.state.appInfo)) {
        this.$router.replace('/rechargeKefu').catch(() => {});
        return true;
      }
      return false;
    },
    selectTab(tab) {
      this.currentTab = tab;
      this.getPaymentMethodsFromBackend();
    },
    getPaymentMethodsFromBackend() {
      let that = this;
      that.showLoading();
      
      const category = that.categoryMap[that.currentTab];
      
      that.$apiFun
        .get('/api/getAllPaymentMethods', { category })
        .then(res => {
          if (res.code == 200 && res.data) {
            that.allPaymentMethods = res.data.map((item, index) => {
              let bonus = '';
              if (item.bonus_ratio) {
                const bonusValue = Math.floor(parseFloat(item.bonus_ratio));
                bonus = `${that.$t('Bonus_Text')}${bonusValue}%`;
              }
              
              return {
                id: item.id,
                type: item.type,
                name: item.name || that.$t('Payment Method'),
                category: that.currentTab,
                img: item.img || '',
                amount: `${item.min_price}-${item.max_price}`,
                bonus: bonus,
                isFee: false,
                min_price: item.min_price,
                max_price: item.max_price,
                data: item.data,
                bonus_ratio: item.bonus_ratio,
                exchange_rate: item.exchange_rate,
                wallet_address: item.wallet_address,
                pay_qrcode: item.pay_qrcode,
                remark: item.data ? item.data.remark : '',
                download_name: item.data ? item.data.download_name : '',
                download_url: item.data ? item.data.download_url : '',
                merchant_identifier: item.merchant_identifier || (item.data && item.data.pay_type && item.data.pay_type.merchant_identifier) || ''
              };
            });
            
            if (that.allPaymentMethods.length > 0) {
              that.selectPaymentMethod(that.allPaymentMethods[0]);
            }
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getPayRange() {
      let that = this;
      let type = null;

      if (that.pay_way == 'bank') type = 'bank';
      if (that.pay_way == 'wechat') type = 'wechat';
      if (that.pay_way == 'alipay') type = 'alipay';
      if (that.pay_way == 'usdt') {
        if (that.meyXi == 'ERC20') type = 'usdt-erc20';
        if (that.meyXi == 'TRC20') type = 'usdt-trc20';
      }
      that.showLoading();

      that.$apiFun
        .post('/api/getPayRange', { type })
        .then(res => {
          if (res.code == 200) {
            that.min_price = res.data.min_price;
            that.max_price = res.data.max_price;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changShow() { this.show = !this.show; },
    onConfirm(value, index) {
      this.bankBox.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() { this.show = false; },
    changXiyi(val) {
      if (this.meyXi == val) return;
      this.meyXi = val;
      this.getPayRange();
    },
    getPayWay() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200 && res.data) {
            that.payWayList = res.data;
            const typeMap = {
              'card': { type: 'bank', name: 'Online Banking Transfer' },
              'usdt': { type: 'usdt', name: 'USDT' },
              'wechat': { type: 'wechat', name: 'WeChat' },
              'alipay': { type: 'alipay', name: 'Alipay' }
            };
            
            that.payTypeList = [];
            for (let key in res.data) {
              if (res.data[key] == 1 && typeMap[key]) {
                that.payTypeList.push({
                  type: typeMap[key].type,
                  name: that.$t(typeMap[key].name),
                  icon: that.getDefaultIcon(typeMap[key].type)
                });
              }
            }
            
            if (that.payTypeList.length > 0) {
              that.pay_way = that.payTypeList[0].type;
              that.getPayMethods(that.pay_way);
            }
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getPayMethods(type) {
      let that = this;
      that.showLoading();
      
      if (type === 'bank') {
        that.$apiFun
          .post('/api/getpaybank', {})
          .then(res => {
            if (res.code == 200 && res.data) {
              that.currentPayMethods = res.data.map((item, index) => ({
                id: item.id || index,
                name: item.bank_data ? item.bank_data.bank_name : that.$t('Bank Card'),
                icon: that.getDefaultIcon('bank'),
                description: item.bank_owner,
                bank_info: {
                  account_no: item.bank_no,
                  account_name: item.bank_owner,
                  bank_name: item.bank_data ? item.bank_data.bank_name : '',
                  bank_address: item.bank_address
                }
              }));
              if (that.currentPayMethods.length > 0) {
                that.selectedMethod = that.currentPayMethods[0];
              }
            }
            that.getPayRange();
            that.hideLoading();
          })
          .catch(res => {
            that.hideLoading();
          });
      } else {
        that.currentPayMethods = [{
          id: 1,
          name: type === 'usdt' ? 'USDT' : type === 'wechat' ? that.$t('WeChat') : that.$t('Alipay'),
          icon: that.getDefaultIcon(type),
          description: ''
        }];
        that.selectedMethod = that.currentPayMethods[0];
        that.getPayRange();
        that.hideLoading();
      }
    },
    selectMethod(method) {
      this.selectedMethod = method;
    },
    getDefaultIcon(type) {
      const iconMap = {
        'bank': '/static/image/icoOnlineTransfer2@3x.png',
        'card': '/static/image/icoOnlineTransfer2@3x.png',
        'usdt': '/static/image/1595237922936176.png',
        'wechat': '/static/image/QuickWechat.png',
        'wxpay': '/static/image/QuickWechat.png',
        'alipay': '/static/image/icoAlipay2@3x.png',
      };
      return iconMap[type] || '/static/image/icoOnlineTransfer2@3x.png';
    },
    payTest() {
      let that = this;
      let info = {};
      const amount = Number(that.depositAmount || that.amount) || 0;
      that.amount = amount;

      if (!that.selectedPaymentMethod && !that.selectedMethod) {
        that.showTost(0, that.$t('Please select a payment method'));
        return;
      }
      if (!that.selectedMethod) {
        that.selectedMethod = that.selectedPaymentMethod;
      }

      if (that.pay_way == 'bank') {
        info = {
          paytype: that.pay_way,
          method_id: that.selectedMethod.id,
          amount: amount,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        if (!info.bank_owner) { that.showTost(0, that.$t("Please enter the depositor's name")); return; }
        if (!info.bank) { that.showTost(0, that.$t('Please enter the bank type')); return; }
        if (!info.bank_no) { that.showTost(0, that.$t('Please enter the bank card number')); return; }
        if (!info.bank_address) { that.showTost(0, that.$t('Please enter the bank account opening address')); return; }
      } else {
        info = {
          paytype: that.isFixpay(that.selectedPaymentMethod || that.selectedMethod) ? 'fixpay' : that.pay_way,
          method_id: that.selectedMethod.id,
          amount: amount,
        };
      }
      if (that.pay_way == 'usdt') {
        info.catepay = that.meyXi;
      }

      if (info.amount < that.min_price || info.amount > that.max_price) {
        that.showTost(0, `${that.$t('Please enter an amount between ')}${that.min_price}${that.$t(' and ')}${that.max_price}${that.$t('!')}`);
        return;
      }
      that.showLoading();
      info.paytype = info.paytype == 'wechat' ? 'wxpay' : info.paytype;

      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            if (that.pay_way == 'bank') {
              that.showTost(1, that.$t('Submitted successfully, waiting for background review'));
              that.bankBox = {};
              that.amount = null;
              that.hideLoading();
              that.$router.push({ path: '/transRecord' });
              return;
            }
            that.bankBox = {};
            that.amount = null;
            that.$router.push({ path: `/payInfo?deposit_no=${res.message}` });
          }
          that.hideLoading();
        })
        .catch(err => {
          that.hideLoading();
          let msg = 'Network error';
          if (err && err.response && err.response.data) {
            msg = err.response.data.message || err.response.data.msg || msg;
          } else if (err && err.message) {
            msg = err.message;
          }
          that.showTost(0, msg);
        });
    },
    changMey(val) {
      this.amount = val * 1;
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) return;
      that.pay_way = val;
      that.bankBox = {};
      that.payInfo = {};
      that.amount = null;
      that.selectedMethod = null;
      that.getPayMethods(val);
    },
    goNav(url) {
      this.$parent.goNav(url);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.showTost(1, this.$t('Copied successfully!'));
    },
    getUserInfo() {
      this.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method;
      if (method.min_price) this.min_price = method.min_price;
      if (method.max_price) this.max_price = method.max_price;
      this.selectedMethod = method;
      
      if (this.isFixpay(method)) {
        this.pay_way = 'fixpay';
      } else if (method.type === 'usdt_pay') {
        this.pay_way = 'usdt';
      } else if (method.data && method.data.type) {
        this.pay_way = method.data.type;
      } else {
        this.pay_way = 'wechat';
      }
    },
    isFixpay(method) {
      if (!method) return false;
      const ident = String(
        method.merchant_identifier ||
        (method.data && method.data.pay_type && method.data.pay_type.merchant_identifier) ||
        (method.data && method.data.payType && method.data.payType.merchant_identifier) ||
        ''
      ).toLowerCase();
      const name = String(method.name || (method.data && method.data.content) || '').toLowerCase();
      return ident === 'fixpay' || ident === 'paythere' || ident === 'pix' || name === 'fixpay' || name === 'pix';
    },
    confirmDeposit() {
      if (!this.canSubmit) return;
      this.amount = Number(this.depositAmount || this.amount) || 0;
      this.payTest();
    },
    selectAmount(val) {
      this.amount = val;
      this.depositAmount = val;
    },
  },
  computed: {
    filteredPaymentMethods() {
      return this.allPaymentMethods;
    },
    canSubmit() {
      const amount = Number(this.depositAmount || this.amount) || 0;
      return this.selectedPaymentMethod && amount && amount >= this.min_price && amount <= this.max_price;
    }
  },
};
</script>

<style lang="scss" scoped>
/* 白底棕金主题 */
.background-gradient {
  background: #ffffff !important;
  min-height: 100vh;
  color: #352b24;
}

.main {
  width: 100%;
  padding: 70px 15px 30px 15px;
  box-sizing: border-box;
}

.containerBlock {
  background: transparent;
  box-sizing: border-box;
}

.tabs-wrapper {
  margin-bottom: 25px;
  
  .tabs-inner {
    display: flex;
    background: #fff8ef;
    border-radius: 40px;
    padding: 6px;
    box-shadow: 0 2px 10px rgba(117, 73, 34, 0.08);
    border: 1px solid #ead1b2;
    
    .tab-item {
      flex: 1;
      text-align: center;
      padding: 10px 0;
      border-radius: 30px;
      font-size: 14px;
      color: #8a6a4a;
      cursor: pointer;
      transition: all 0.3s ease;
      font-weight: 500;
      position: relative;
      
      &.active {
        background: linear-gradient(135deg, #ffe082, #d1a03e);
        color: #5c3a00;
        font-weight: bold;
        box-shadow: 0 3px 12px rgba(209, 160, 62, 0.35);
      }
    }
  }
}

.methodsDeposit {
  margin-bottom: 25px;
  
  .eWalletList {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    
    .wallet-item {
      width: calc(33.33% - 8px);
      height: 100px;
      background: #ffffff;
      border-radius: 14px;
      border: 1px solid #eadfd3;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(117, 73, 34, 0.08);
        
      &.active {
        background: #fffaf3;
        border-color: #d1a03e;
        box-shadow: 0 0 0 1px #d1a03e, 0 6px 15px rgba(209, 160, 62, 0.2);
      }
        
      .bonus-ribbon {
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(135deg, #ff4d4d, #c60000);
        color: #fff;
        padding: 3px 8px;
        font-size: 11px;
        font-weight: bold;
        z-index: 10;
        border-radius: 0 0 10px 0;
      }
      
      .method-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .img-box {
          height: 38px;
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          
          img {
            max-width: 50px;
            max-height: 100%;
            object-fit: contain;
          }
        }
        
        .method-name {
          font-size: 13px;
          font-weight: 500;
          color: #352b24;
          text-align: center;
        }
      }

      .check-mark {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 0;
        height: 0;
        border-bottom: 24px solid #d1a03e;
        border-left: 24px solid transparent;
        
        &::after {
          content: '✓';
          position: absolute;
          right: 2px;
          bottom: -22px;
          color: #fff;
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
  }
}

.depositAmountSet {
  margin-bottom: 30px;
  background: #ffffff;
  border-radius: 20px;
  padding: 24px 20px;
  border: 1px solid #eadfd3;
  box-shadow: 0 5px 18px rgba(117, 73, 34, 0.08);
  
  .amount-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #352b24;
      letter-spacing: 0.5px;
    }
    
    .download-btn {
      color: #8f501f;
      padding: 6px 14px;
      border-radius: 20px;
      font-size: 12px;
      background: #fff8ef;
      border: 1px solid #d9b98f;
      text-decoration: none;
      transition: all 0.3s;
      
      &:hover {
        background: #fff2df;
      }
    }
  }
  
  .amount-input-wrapper {
    position: relative;
    margin-bottom: 25px;
    display: flex;
    align-items: flex-end;
    border-bottom: 2px solid #ead1b2;
    padding-bottom: 8px;
    transition: border-color 0.3s;

    &:focus-within {
      border-bottom-color: #d1a03e;
    }
    
    .currency {
      font-size: 26px;
      color: #b87333;
      font-weight: bold;
      margin-right: 10px;
      padding-bottom: 2px;
    }
    
    .amount-input {
      flex: 1;
      border: none;
      background: transparent;
      color: #352b24;
      font-size: 36px;
      font-weight: bold;
      outline: none;
      width: 100%;
      caret-color: #d1a03e;
      
      &::placeholder {
        color: #c0b0a0;
        font-size: 18px;
        font-weight: normal;
        transform: translateY(-5px);
      }
      
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
    
    .payment-remark {
      position: absolute;
      right: 0;
      top: 5px;
      color: #8a6a4a;
      font-size: 12px;
    }
  }
  
  .quick-amount-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    
    .quick-btn {
      background: #fff8ef;
      border: 1px solid #ead1b2;
      border-radius: 8px;
      padding: 12px 0;
      font-size: 15px;
      font-weight: 500;
      color: #5c3a12;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;
      
      &.active {
        background: #fff2df;
        border: 1px solid #d1a03e;
        color: #8f501f;
        font-weight: bold;
        box-shadow: 0 3px 10px rgba(209, 160, 62, 0.18);
      }
    }
  }
}

.submit-action {
  margin-bottom: 40px;
  
  .btn-submit {
    position: relative;
    width: 100%;
    height: 54px;
    background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%);
    color: #4a2e00;
    border: none;
    border-radius: 14px;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 2px;
    cursor: pointer;
    overflow: hidden;
    box-shadow: 0 6px 20px rgba(209, 160, 62, 0.35);
    transition: all 0.3s;
    
    .btn-text {
      position: relative;
      z-index: 2;
    }
    
    .btn-light {
      position: absolute;
      top: 0;
      left: -100%;
      width: 50%;
      height: 100%;
      background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%);
      transform: skewX(-25deg);
      animation: sweep 3s infinite;
      z-index: 1;
    }
    
    &.disabled {
      background: #ece4d8;
      color: #a89888;
      box-shadow: none;
      cursor: not-allowed;
      .btn-light { display: none; }
    }
    
    &:active:not(.disabled) {
      transform: translateY(2px);
      box-shadow: 0 2px 10px rgba(209, 160, 62, 0.35);
    }
  }
}

@keyframes sweep {
  0% { left: -100%; }
  20% { left: 200%; }
  100% { left: 200%; }
}
</style>


// WEBPACK FOOTER //
// src/components/recharge.vue